<template>
  <v-card :id="elementId.concat(appendElementId ? `-${appendElementId}` : '')">
    <v-card-title :class="`${dialogClass} headline${mobileMode ? ' py-1' : ''}`">
      <span>{{$t('adjustColumns')}}</span>
      <v-spacer/>
      <BaseDialogActions
        v-if="mobileMode || showClose"
        hideRefresh
        hideFullscreen
        customCancel
        @close="$emit('close')"/>
    </v-card-title>

    <v-card-text :class="mobileMode ? 'pa-0' : 'mt-1'">
      <v-container :style="mobileMode ? '' : containerStyle">
        <slot :columnSet="columnSets[0]" :columnSets="columnSets">
          <ColumnToggleGrid :columns="adjustableColumns" @toggle="column => columnSets[0].toggleColumn(column.id)"/>
        </slot>
      </v-container>
    </v-card-text>

    <v-card-actions :class="'pb-4'.concat(mobileMode ? ' px-0 mx-3' : '')">
      <v-row no-gutters>
        <v-col>
          <v-btn
            id="reset"
            v-if="showReset"
            :color="dialogColor"
            @click="$emit('reset')"
            :disabled="!changed"
            outlined>
            {{$t('reset')}}
          </v-btn>
        </v-col>

        <v-col cols="auto">
          <v-btn
            id="apply"
            :class="dialogClass"
            @click="applyClicked"
            :disabled="!changed">
            {{$t('apply')}}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ColumnSet } from '@/model/DataTableColumn.js'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ColumnAdjusterCard',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue'),
    ColumnToggleGrid: () => import('@/components/core/ColumnToggleGrid.vue')
  },

  props: {
    propColumnSet: ColumnSet,
    propColumnSets: {
      type: Array,
      default: undefined
    },
    mobileMode: {
      type: Boolean,
      default: false
    },
    showReset: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: false
    },
    dialogColor: {
      type: String,
      default: 'primary'
    },
    containerStyle: {
      type: Object,
      default: undefined
    },
    elementId: {
      type: String,
      default: 'column-adjuster'
    },
    appendElementId: {
      type: String,
      default: undefined
    }
  },

  data () {
    return {
      columnSets: (this.propColumnSets ?? [this.propColumnSet]).map(columnSet => columnSet.clone()),
      changed: false
    }
  },

  computed: {
    ...mapGetters('user-settings', ['mutatedUserSettings']),

    dialogClass () {
      return `${this.dialogColor} white--text`
    },

    adjustableColumns () {
      return this.columnSets[0].getAdjustableColumns()
    }
  },

  watch: {
    columnSets: {
      handler () {
        this.changed = true
      },
      deep: true
    }
  },

  methods: {
    ...mapActions('user-settings', ['updateUserSettings']),

    applyClicked () {
      this.columnSets.forEach(columnSet => columnSet.commitColumnInfo())
      if (this.columnSets.some(columnSet => columnSet.userSettingKey)) this.updateUserSettings(this.mutatedUserSettings)
      this.$emit('apply', this.columnSets[0])
    }
  }
}
</script>
